import { Injectable } from '@angular/core';
import { ParentService } from '../pages/A2-utils/ParentClass/ParentService';
import { Http, Response } from '@angular/http';
import { constant } from '../app.constants';
import { Observable } from 'rxjs/Observable';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';

@Injectable()
export class CountyService extends ParentService {

  constructor(private _http: Http, private toastrAlertHelper: ToastrAlertHelper) {
    super();
  }

  getCountys() {
    const url = constant.URL_COUNTY;
    return this._http.get(url, this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error));
  }

  storeCounty(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_COUNTY, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw( this.toastrAlertHelper.error(error.json().message)));
  }

  deleteCounty(countyid: number) {
    const url = constant.URL_COUNTY + '/' + countyid;
    return this._http.delete(url, this.getHeader())
    .map((res: Response) => res.json())
    .catch((error: any) => Observable.throw(error.json()));
  }

  getCounty(countyid: number) {
    const url = constant.URL_COUNTY_ZIP_CODE + '/' + countyid;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  updateCounty(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.put(constant.URL_COUNTY_COUNTY_UPDATE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  storeProviderCountyZipCode(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_PROVIDER_COUNTY_ZIP_CODE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw( this.toastrAlertHelper.error(error.json().message)));
  }

  getProviderCountyZipCode(CountyId: number) {
    const url = constant.URL_GET_PROVIDER_COUNTY_Zip_CODE + '/' + CountyId;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  updateProviderCountyZipCode(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.put(constant.URL_PROVIDER_COUNTY_ZIP_CODE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw( this.toastrAlertHelper.error(error.json().message)));
  }

  getCountyById(CountyId: number) {
    const url = `${constant.URL_COUNTY}/${CountyId}`;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    ).catch((error: any) => Observable.throw(error.json()));
  }

  postCounty(data) {
    return this._http.post(constant.URL_COUNTY, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  putCounty(data) {
    return this._http.put(constant.URL_COUNTY, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/county.service.ts